import affiliates from './affiliates/affiliates';
import basketButton from './basketButton/basketButton';
import category from './category/category';
import checkout from './checkout/checkout';
import compare from './compare/compare';
import compareButton from './compareButton/compareButton';
import evaluation from './evaluation/evaluation';
import favoriteButton from './favoriteButton/favoriteButton';
import filter from './filter/filter';
import filterButton from './filterButton/filterButton';
import growl from './growl/growl';
import home from './home/home';
import imgCarousel from './imgCarousel/imgCarousel';
import invoiceModal from './invoiceModal/invoiceModal';
import commentsButton from './commentsButton/commentsButton';
import invoices from './invoices/invoices';
import leaderboard from './leaderboard/leaderboard';
import login from './login/login';
import more from './more/more';
import process from './process/process';
import product from './product/product';
import productBox from './productBox/productBox';
import ranking from './ranking/ranking';
import search from './search/search';
import searchInput from './searchInput/searchInput';
import searchWidget from './searchWidget/searchWidget';
import statistic from './statistic/statistic';
import statistics from './statistics/statistics';
import stock from './stock/stock';
import support from './support/support';
import tabs from './tabs/tabs';
import upsell from './upsell/upsell';
import valuebar from './valuebar/valuebar';

const componentModule = angular.module('app.components', [
	affiliates,
	basketButton,
	category,
	checkout,
	compare,
	compareButton,
	evaluation,
	favoriteButton,
	filter,
	filterButton,
	growl,
	home,
	imgCarousel,
	invoiceModal,
	commentsButton,
	invoices,
	leaderboard,
	login,
	more,
	process,
	product,
	productBox,
	ranking,
	search,
	searchInput,
	searchWidget,
	statistic,
	statistics,
	stock,
	support,
	tabs,
	upsell,
	valuebar,
])
.name;

export default componentModule;


// WEBPACK FOOTER //
// ./app/components/components.js